import React from 'react';
import { useTranslation } from 'react-i18next';

import ModalMC from '../../../components/ModalMC';
import IconMC from '../../../components/IconMC';

const WhatsappFlowsBspAlertModalMC = ({ visible, onClose }) => {
  const { t } = useTranslation('WhatsappFlowsScreenMC');

  const handleContactSupport = () => {
    if (window.Intercom) {
      window.Intercom('show');
    }
    onClose();
  };

  return (
    <ModalMC
      visible={visible}
      onClose={onClose}
      title={t('landing.bsp_alert.title')}
      className="tw-px-6 tw-pb-2"
      buttons={[
        {
          label: t('landing.bsp_alert.cta'),
          onClick: handleContactSupport,
          icon: 'message-circle-outline',
          iconPosition: 'left'
        }
      ]}
    >
      <div className="tw-flex tw-items-start tw-gap-3 tw-py-2">
        <IconMC name="alert-circle-outline" className="tw-mt-0.5 tw-shrink-0 tw-text-amber-600" size="lg" />
        <p className="tw-text-sm tw-leading-6 tw-text-gray-700">
          {t('landing.bsp_alert.description')}
        </p>
      </div>
    </ModalMC>
  );
};

export default WhatsappFlowsBspAlertModalMC;
